export const aboutPageContent = {
    en: {
        aboutUPPER: "ABOUT",
        aboutRevimo: "About Revimo",
        ourStory: "Our Story",
        aboutDescription: `Revimo is an online physiotherapy platform designed for
        easier and faster recovery, muscle srenghtening and fitness improvement. 
        Revimo enables cheaper physiotherapy whitout compromising professionality and the quality of your sessions.`,
        ourStory1: `Revimo was born out of real experiences with surgeries, rehabilitation and the long journeys back to full movement. 
        After several operations in childhood, physiotherapy became a normal part of life,
        and over time, sports and rehab knowledge turned into a personal routine.
        During recovery from the latest surgery, the idea appeared: 
        what if structured, physiotherapy could be available online to anyone, at any time, without depending on appointment slots, and budget?`,
        ourStory2: `Today, Revimo is an online physiotherapy platform with clear video sessions, structured plans and daily guidance people can follow from home.
        It is designed not only for those who need recovery programs after injury or surgery, but also for anyone who wants to build overall body strength and a healthier,
        more active lifestyle. Instead of relying only on occasional live visits, users get ongoing support that fits into real life and can be accessed without having a lot of free time or money.
        Our goal is to make quality movement and rehabilitation support truly accessible, so more people can move better, feel stronger and recover smarter.`,
        ourStoryShort: `Revimo started from many rehab journeys and a simple idea: structured physiotherapy should be available online to anyone, anytime – not limited by waiting lists,
        schedules or financial background. Today, Revimo offers guided video sessions and programs that support recovery, strength and a healthier lifestyle from home.`,
        atGlance: {
            title: "At a glance",
            label: {
            founded: "Founded:",
            headquarters: "Headquarters:",
            coreFocus: "Core focus:",
            costumers: "Costumers:",
            markets: "Markets:",
            },
            value: {
            founded: "2026",
            headquarters: "Maribor, Slovenia",
            coreFocus: "Guided online physiotherapy for faster recovery, more strength, and a healthier life.",
            costumers: "1,000+ users",
            markets: "Europe, Slovenia",
            },
        },
        eTitle: "Why we exist?",
        Omission: "Our mission",
        mission: "We would like to bring professional physiotherapy into everyone’s home, sharing knowledge and experience worldwide to create a happier and healthier future.",
        Ovision: "Our vison",
        vision: `A world where everyone can access professional physiotherapy guidance anytime, anywhere—from home. 
  Quality recovery, strength training, and movement become simple, affordable, and available to all—no waiting rooms, no high costs, just results.`,
        Ovalues: "Our values",
        values: {
            wellbeing: "Wellbeing - We support the whole person. Not just injury recovery, but long‑term physical and mental wellbeing.",
            healthyMovement: "Healthy movement - We promote safe, smart movement that builds strength, confidence and better everyday function.",
            accessibility: "Accessibility - Quality physiotherapy guidance should be reachable from anywhere, at any time, regardless of schedule.",
        },
    },
    sl: {
        aboutUPPER: "O NAS",
        aboutRevimo: "O Revimo",
        ourStory: "Naša zgodba",
        aboutDescription: `Revimo je spletna fizioterapevtska platforma, zasnovana za lažje in hitrejše okrevanje, krepitev mišic in izboljšanje telesne pripravljenosti. Omogoča ugodnejšo fizioterapijo, ne da bi pri tem žrtvovali strokovnost ali kakovost.`,
        ourStory1: `Revimo je nastal iz mnogih izkušenj z operacijami, rehabilitacijo in poti nazaj do popolnega gibanja.
        Po več operacijah v otroštvu je fizioterapija postala normalen del življenja, šport in znanje o najrazličnejših vajah pa sta se sčasoma razvila v znanje, pridobljeno z izkušnjami.
        Med okrevanjem po zadnji operaciji se je pojavila ideja, kaj, če bi bila strukturirana fizioterapija na voljo vsakomur, kadarkoli – ne glede na količino prostega časa in finančnega stanja.`,
        ourStory2: `Danes je Revimo spletna platforma za fizioterapijo z jasnimi video vadbami, strukturiranimi programi in vsakodnevnimi usmeritvami,
        ki jih lahko uporabniki izvajajo doma. Namenjena ni samo tistim, ki potrebujejo programe po poškodbah ali operacijah, ampak tudi vsem,
        ki želijo okrepiti telo in živeti bolj zdravo, aktivno življenje. Namesto da bi bili odvisni le od občasnih terminov v živo, uporabniki dobijo stalno podporo,
        ki se prilagodi njihovemu urniku, in je dostopna tudi tistim, ki nimajo veliko prostega časa ali finančnih zmožnosti. 
        Naš cilj je, da kakovostna podpora pri gibanju in rehabilitaciji postane resnično dostopna čim širšemu krogu ljudi – da se lahko več ljudi bolje giba, se počuti močnejše in okreva pametneje.`,
        ourStoryShort: `Revimo je nastal zaradi mnogih izkušenj z rehabilitacijo in iz preprostega spoznanja, da bi morala biti strukturirana fizioterapija na voljo vsakomur,
        kadarkoli – ne glede na čakalne vrste, urnik ali finančno ozadje. Danes Revimo ponuja vodene video vadbe in programe, ki od doma podpirajo okrevanje, moč in bolj zdrav, aktiven življenjski slog.`, 
        atGlance: {
            title: "Na hitro o Revimu",
            label: {
                founded: "Ustanovljeno:",
                headquarters: "Sedež:",
                coreFocus: "Osrednji fokus:",
                costumers: "Uporabniki:",
                markets: "Trgi:",
            },
            value: {
                founded: "2026",
                headquarters: "Maribor, Slovenija",
                coreFocus:
                "Vodena spletna fizioterapija za hitro okrevanje, več moči in bolj zdravo življenje.",
                costumers: "1.000+ uporabnikov",
                markets: "Evropa, Slovenija",
            },
        },
        eTitle: "Zakaj obstajamo?",
        Omission: "Naš namen",
        mission: "Naš namen je približati profesionalno fizioterapijo domu, delili znanje in izkušnje po vsem svetu ter ustvariti srečnejšo in bolj zdravo prihodnost.",
        Ovision: "Naša vizija",
        vision: `Svet, kjer ima vsak dostop do strokovnih fizioterapevtskih navodil kadarkoli in kjerkoli. 
  Kakovostno okrevanje, krepitev in gibanje postanejo preprosta, cenovno dostopna in na voljo vsem; brez čakalnic, brez visokih stroškov, samo rezultati.`,
        Ovalues: "Naše vrednote",
            values: {
            wellbeing:
                "Dobro počutje – Podpiramo celotnega človeka, ne le okrevanja po poškodbah, ampak tudi dolgoročno telesno in psihično počutje.",
            healthyMovement:
                "Zdravo gibanje – Spodbujamo varno in premišljeno gibanje, ki krepi telo, samozavest in vsakodnevno funkcionalnost.",
            accessibility:
                "Dostopnost – Kakovostna fizioterapevtska podpora naj bo dosegljiva od kjerkoli, kadarkoli, ne glede na urnik.",
            },

    },
} as const;
export type Lang = keyof typeof aboutPageContent;